import {
  FuelButton,
  FuelGridItem,
  FuelTypography,
  FuelRadio,
  FuelGridContainer,
} from '@frete.com/fuel-react'
import * as Styled from './styled'
import Form from '~components/Form'
import { Props, Values } from './interfaces'
import { defaultFormSchema, } from './validation'
import { Text } from '~constants/text'
import { dsTokens } from 'ds'
import { useTranslator } from '~hooks'
import { money } from '~utils/parses/money'
import { getNextRenewDay, shouldDisplaySavings } from '../../utils'

function FormPurchaseExtraUsers({ handleSubmit, rangePrice, renewDay, loading }: Props) {
  const { translate } = useTranslator()

  const initialValues = {
    amount: '',
  }

  return (
    <Form<Values>
      initialValues={initialValues}
      onSubmit={handleSubmit}
      enableReinitialize
      validationSchema={defaultFormSchema}
    >
      {({ values, handleChange, setFieldValue }) => {
        return (
          <Styled.FormWrapper>
            <FuelGridContainer gapRow={24} style={{ height: '100%'}}>
              <FuelGridItem xlg={12} lg={12} md={8} sm={4}>
                <Styled.Content>
                  <Styled.MainContentWrapper>
                    <Styled.TitleSession>
                      {translate(Text.SELECT_USER_AMOUNT)}
                    </Styled.TitleSession>
                    <Styled.RangePriceWrapper>
                      {rangePrice.map(({price, amount}, idx) => (
                        <Styled.RangePriceItem key={idx}>
                          <FuelRadio
                            onClick={async (e) => {
                              handleChange(e)
                              await setFieldValue('amount', `${amount}`)
                            }}
                            label={`${amount} ${translate(Text.EXTRA_USERS, { plural: amount > 1 ? 's' : '' })}`}
                            name="amount"
                            checked={values.amount === amount.toString()}
                            value={values.amount}
                          />
                          <FuelTypography size="heading-lg" weight="bold" 
                            spacingBottom={parseFloat(dsTokens.spacing.km8)}
                            spacingTop={parseFloat(dsTokens.spacing.km8)}
                          >
                            {money(price)}
                          </FuelTypography>

                          {amount > 1 && (
                            <>
                              <FuelTypography 
                                size="body-sm"
                                weight="regular"
                                color='neutral-default' 
                                spacingBottom={parseFloat(dsTokens.spacing.km3)}
                              >
                                {translate(Text.EACH_USER_WILL_COAST, { amount: money(price / amount)})}
                              </FuelTypography>

                              {shouldDisplaySavings(rangePrice) && (
                                <div style={{ color: dsTokens.color.support.blue.strong }}>
                                  <FuelTypography
                                    size="body-sm"
                                    weight="regular"
                                    color='inherit'
                                    spacingTop={parseFloat(dsTokens.spacing.km4)}
                                    >
                                    {translate(Text.ECONOMIZE, { amount: money(rangePrice[0].price * amount - price) })}
                                  </FuelTypography> 
                                </div>                                  
                              )}
                            </>
                          )}

                          {amount === 1 && (
                            <FuelTypography 
                              size="body-sm"
                              weight="regular"
                              color='neutral-default' 
                              spacingBottom={parseFloat(dsTokens.spacing.km8)}
                              spacingTop={parseFloat(dsTokens.spacing.km8)}
                            >
                              {translate(Text.UNIT_COAST)}
                            </FuelTypography>
                          )}
                        </Styled.RangePriceItem>
                      ))}
                    </Styled.RangePriceWrapper>
                  </Styled.MainContentWrapper>
                  <Styled.RangePriceSelectedInfo>
                    <FuelTypography
                      weight="bold"
                      size="body-sm"
                    >
                      {translate(Text.AMOUNT_CHARGED_NEXT_INVOICE)} {getNextRenewDay(renewDay)}
                    </FuelTypography>
                    {values.amount !== '' && (
                      <FuelTypography weight='bold' size='body-lg'>
                        {money(parseFloat(values.amount))}
                      </FuelTypography>
                    )}
                  </Styled.RangePriceSelectedInfo>
                </Styled.Content>
              </FuelGridItem>
              <FuelGridItem xlg={12} lg={12} md={8} sm={4}>
                <Styled.Buttons>
                  <FuelButton
                    type="submit"
                    size="large"
                    isLoading={loading}
                    disabled={values.amount === '' }
                  >
                    {translate(Text.AGREE_AND_CONTINUE)}
                  </FuelButton>
              </Styled.Buttons>
            </FuelGridItem>
            </FuelGridContainer>
          </Styled.FormWrapper>
        )
      }}
    </Form>
  )
}

export default FormPurchaseExtraUsers
